{
  "AuForumAssurance_Periwinkle-light": "#e2dcfe",
  "AuForumAssurance_Periwinkle": "#c4b8fe",
  "AuForumAssurance_Periwinkle-dark": "#755de9",
  "AuForumAssurance_Blue-100": "#e7f2fe",
  "AuForumAssurance_Blue-500": "#0b61b7",
  "AuForumAssurance_Blue-900": "#042647",
  "AuForumAssurance_Green-100": "#e8fcee",
  "AuForumAssurance_Green-500": "#108910",
  "AuForumAssurance_Green-900": "#074007",
  "AuForumAssurance_Orange-100": "#fff3e6",
  "AuForumAssurance_Orange-500": "#f68904",
  "AuForumAssurance_Orange-900": "#593201",
  "AuForumAssurance_Red-100": "#fceae8",
  "AuForumAssurance_Red-500": "#da2616",
  "AuForumAssurance_Red-900": "#591009",
  "AuForumAssurance_Jasmine": "#fcee82",
  "AuForumAssurance_Mindaro": "#a1f7a7",
  "AuForumAssurance_Peach": "#f7917d",
  "AuForumAssurance_Sky": "#a2ddff",
  "AuForumAssurance_Red-200": "#fcd4d0",
  "AuForumAssurance_Red-600": "#c42213",
  "AuForumAssurance_Orange-200": "#fde7cc",
  "AuForumAssurance_Orange-600": "#e47d00",
  "AuForumAssurance_Blue-200": "#d5eaff",
  "AuForumAssurance_Blue-600": "#064f97",
  "AuForumAssurance_Green-600": "#0d730d",
  "AuForumAssurance_Green-200": "#d1fadd",
  "AuForumAssurance_Black": "#000000",
  "AuForumAssurance_White": "#ffffff",
  "AuForumAssurance_Gray700": "#424242",
  "AuForumAssurance_Gray800": "#151318",
  "AuForumAssurance_Gray600": "#666666",
  "AuForumAssurance_Gray100": "#f8f7f7",
  "AuForumAssurance_Gray500": "#999999",
  "AuForumAssurance_Gray400": "#b8b8b8",
  "AuForumAssurance_Gray300": "#d6d6d6",
  "AuForumAssurance_Gray200": "#e8e8e8",
  "AuForumAssurance_Gray-50": "#fbfbfb",
  "AuForumAssurance_Orange-chaud": "#e8751a",
  "AuForumAssurance_Rouge-brule": "#d94420",
  "AuForumAssurance_Cramoisi": "#c41e3a",
  "AuForumAssurance_Magenta": "#9b1b5e",
  "AuForumAssurance_Cream-50": "#faf8f5",
  "AuForumAssurance_Cream-100": "#f5efe6",
  "AuForumAssurance_Cream-200": "#efe8db",
  "AuForumAssurance_Cream-300": "#e5dac5",
  "AuForumAssurance_Ink-900": "#1a1614",
  "AuForumAssurance_Ink-700": "#3b3530",
  "AuForumAssurance_Ink-500": "#6b635c",
  "AuForumAssurance_Ink-400": "#8a8178",
  "Periwinkle-light": "#E2DCFE",
  "Periwinkle": "#C4B8FE",
  "Periwinkle-dark": "#755DE9",
  "Blue-100": "#E7F2FE",
  "Blue-500": "#0B61B7",
  "Blue-900": "#042647",
  "Green-100": "#E8FCEE",
  "Green-500": "#108910",
  "Green-900": "#074007",
  "Orange-100": "#FFF3E6",
  "Orange-500": "#F68904",
  "Orange-900": "#593201",
  "Red-100": "#FCEAE8",
  "Red-500": "#DA2616",
  "Red-900": "#591009",
  "Jasmine": "#FCEE82",
  "Mindaro": "#A1F7A7",
  "Peach": "#F7917D",
  "Sky": "#A2DDFF",
  "Red-200": "#FCD4D0",
  "Red-600": "#C42213",
  "Orange-200": "#FDE7CC",
  "Orange-600": "#E47D00",
  "Blue-200": "#D5EAFF",
  "Blue-600": "#064F97",
  "Green-600": "#0D730D",
  "Green-200": "#D1FADD",
  "Black": "#000000",
  "White": "#FFFFFF",
  "Gray700": "#424242",
  "Gray800": "#151318",
  "Gray600": "#666666",
  "Gray100": "#F8F7F7",
  "Gray500": "#999999",
  "Gray400": "#B8B8B8",
  "Gray300": "#D6D6D6",
  "Gray200": "#E8E8E8",
  "Dealt_Black": "#000000",
  "Dealt_Primary": "#b24dff",
  "Dealt_White": "#ffffff",
  "Dealt_Red-500": "#da5418",
  "Dealt_Primary-light": "#db9eff",
  "Dealt_Primary-dark": "#8d36d9",
  "Dealt_Red-600": "#bc4813",
  "Dealt_Accent-01": "#ffcea3",
  "Dealt_Red-100": "#ffe1d4",
  "Dealt_Red-200": "#ffc1a5",
  "Dealt_Primary-light-2": "#f3deff",
  "Legacy-Black": "#000000",
  "Legacy-White": "#FFFFFF",
  "Legacy-Linen": "#FEFEFF",
  "Legacy-Blue-900": "#03001A",
  "Legacy-Blue-800": "#070042",
  "Legacy-Blue-700": "#0D0080",
  "Legacy-Blue-600": "#1F0CC9",
  "Legacy-Blue-500": "#4A37F2",
  "Legacy-Blue-400": "#9F94FF",
  "Legacy-Blue-300": "#DBD6FF",
  "Legacy-Blue-200": "#EEEDFF",
  "Legacy-Blue-100": "#FAFAFF",
  "Legacy-Green-900": "#02200E",
  "Legacy-Green-800": "#063519",
  "Legacy-Green-700": "#0C6A32",
  "Legacy-Green-600": "#129F4A",
  "Legacy-Green-500": "#18D463",
  "Legacy-Green-400": "#51EC8E",
  "Legacy-Green-300": "#91F3B9",
  "Legacy-Green-200": "#CCF8DE",
  "Legacy-Green-100": "#EDFFF4",
  "Legacy-Yellow-900": "#1D1902",
  "Legacy-Yellow-800": "#433A00",
  "Legacy-Yellow-700": "#9E8A00",
  "Legacy-Yellow-600": "#D9BD00",
  "Legacy-Yellow-500": "#FFE428",
  "Legacy-Yellow-400": "#FFEB62",
  "Legacy-Yellow-300": "#FFF195",
  "Legacy-Yellow-200": "#FFF8CB",
  "Legacy-Yellow-100": "#FFFDEE",
  "Legacy-Orange-900": "#271704",
  "Legacy-Orange-800": "#794202",
  "Legacy-Orange-700": "#B76202",
  "Legacy-Orange-600": "#FA8803",
  "Legacy-Orange-500": "#FE9925",
  "Legacy-Orange-400": "#FEB765",
  "Legacy-Orange-300": "#FED7AA",
  "Legacy-Orange-200": "#FFE9CF",
  "Legacy-Orange-100": "#FFF8EF",
  "Legacy-Red-900": "#270406",
  "Legacy-Red-800": "#590106",
  "Legacy-Red-700": "#A7020C",
  "Legacy-Red-600": "#DE1925",
  "Legacy-Red-500": "#FD3541",
  "Legacy-Red-400": "#FE6F78",
  "Legacy-Red-300": "#FEAAAF",
  "Legacy-Red-200": "#FFDBDD",
  "Legacy-Red-100": "#FFEFF0",
  "Legacy-Gray-900": "#18171A",
  "Legacy-Gray-800": "#35353B",
  "Legacy-Gray-700": "#4D4C52",
  "Legacy-Gray-600": "#706F76",
  "Legacy-Gray-500": "#929199",
  "Legacy-Gray-400": "#C0BFC7",
  "Legacy-Gray-300": "#D9D8E1",
  "Legacy-Gray-200": "#E6E5ED",
  "Legacy-Gray-100": "#F1F0F5",
  "Legacy-Peach-dark": "#FFC4A2",
  "Legacy-Peach-light": "#FFE6D5",
  "Legacy-Jasmine-dark": "#FFECA8",
  "Legacy-Jasmine-light": "#FFF8DE",
  "Legacy-Mindaro-dark": "#E1F5A8",
  "Legacy-Mindaro-light": "#EFF9CE",
  "Legacy-Sky-dark": "#C9F0FC",
  "Legacy-Sky-light": "#DBF7FF",
  "Legacy-Periwinkle-dark": "#DED1F9",
  "Dougs_Blue-400": "#11ABEC",
  "Dougs_Blue-100": "#F2F7FB",
  "Dougs_Blue-200": "#DFF1FA",
  "Dougs_Blue-300": "#C0E0ED",
  "Dougs_Blue-500": "#18303E",
  "Dougs_Blue-600": "#010D16",
  "Gray-50": "#fbfbfb",
  "Indy_Black-100": "#171514",
  "Indy_White": "#ffffff",
  "Indy_Grey-100": "#f3f6f9",
  "Indy_Grey-20": "#2e4254",
  "Indy_Blue-100": "#e8fcff",
  "Indy_Blue-20": "#0d7988",
  "Indy_Purple-100": "#fbf3ff",
  "Indy_Purple-20": "#63217c",
  "Indy_Orange-100": "#ffefe0",
  "Indy_Orange-20": "#e16200",
  "Indy_Pink-100": "#ffecf1",
  "Indy_Pink-20": "#fa5d89",
  "Indy_Red-100": "#ffe2e2",
  "Indy_Red-20": "#be2c02",
  "Indy_Green-100": "#e2fff3",
  "Indy_Green-20": "#04be70",
  "Indy_Teal-100": "#dcfff5",
  "Indy_Teal-20": "#08a798",
  "Indy_Beige-100": "#fef7ec",
  "Indy_Beige-20": "#60503a",
  "Indy_Pink-40": "#ff6c96",
  "Indy_Grey-0": "#222c36",
  "Indy_Grey-40": "#5e7387",
  "Indy_Grey-80": "#d8e1e9",
  "Indy_Grey-60": "#a6bacb",
  "Indy_Back-101": "#ffffff",
  "Indy_Pink-80": "#ffc3d4",
  "Jump_Identity-900": "#020034",
  "Jump_Identity-500": "#35335D",
  "Jump_Positive-100": "#E4FAFB",
  "Jump_Positive-200": "#BBF2F6",
  "Jump_Positive-400": "#1CD3DF",
  "Jump_Gray-900": "#000000",
  "Jump_Gray-800": "#2E2E2E",
  "Jump_Gray-700": "#474747",
  "Jump_Gray-200": "#EDEDED",
  "Jump_Gray-600": "#666666",
  "Jump_Neutral-000": "#FFFFFF",
  "Jump_Neutral-700": "#3D5266",
  "Jump_Accent1-100": "#EEEBFF",
  "Jump_Accent1-200": "#D9D4FF",
  "Legacy-Periwinkle-light": "#F1EBFC",
  "LP_Blue-500": "#3392FF",
  "LP_Blue-600": "#2571DB",
  "LP_Blue-700": "#1954B7",
  "LP_Grey-200": "#DEE2E6",
  "LP_Red-500": "#E0182D",
  "LP_Green-600": "#0EB290",
  "LP_Orange-500": "#FF9800",
  "LP_Red-600": "#C01133",
  "LP_Red-700": "#A10C37",
  "LP_Blue-900": "#051259",
  "LP_Grey-150": "#EAEEF1",
  "LP_Grey-25": "#F9FAFB",
  "LP_Grey-300": "#BDC4CB",
  "LP_Grey-400": "#868E96",
  "LP_Grey-600": "#495057",
  "LP_Grey-50": "#FBFCFD",
  "LP_Grey-100": "#F6F9FC",
  "LP_Orange-100": "#FFF2CC",
  "LP_Decorative": "#FFF6E1",
  "Legalstart_LS-yellow": "#E9EB7A",
  "Legalstart_LS-blue": "#94B3FD",
  "Legalstart_LS-dark-green": "#033230",
  "Legalstart_LS-beige": "#EDEEE2",
  "Legalstart_LS-dark-blue": "#6F7CEF",
  "Legalstart_LS-white": "#FFFFFF",
  "Legalstart_LS-dark-grey": "#3C3C3C",
  "Legalstart_LS-grey": "#656565",
  "Legalstart_LS-light-grey": "#D0D0D0",
  "Legalstart_LS-dark-beige": "#D3D6C3",
  "Legalstart_LS-light-yellow": "#FDFFA0",
  "Obat_Black": "#1e232f",
  "Obat_Blue-primary": "#1591f0",
  "Obat_Blue-secondary": "#172c76",
  "Obat_White": "#ffffff",
  "Obat_Blue-02": "#39a2f2",
  "Obat_Blue-03": "#4facf3",
  "Obat_Blue-04": "#65b7f5",
  "Obat_Blue-05": "#7bc1f6",
  "Obat_Blue-06": "#91cbf8",
  "Obat_Grey-00": "#020203",
  "Obat_Grey-01": "#2c2f3d",
  "Obat_Grey-02": "#3f4357",
  "Obat_Grey-03": "#969cb4",
  "Obat_Grey-07": "#b1b4c6",
  "Obat_Grey-08": "#cbcdd9",
  "Obat_Grey-09": "#e5e6ec",
  "Obat_Blue-01": "#1591f0",
  "Obat_Green-02": "#71c848",
  "Obat_Red-02": "#eb6262",
  "Obat_Amber-02": "#fab352",
  "Obat_Green-01": "#63be39",
  "Obat_Green-03": "#81ce5c",
  "Obat_Red-01": "#e84b4b",
  "Obat_Red-03": "#ed7373",
  "Obat_Amber-01": "#f9a839",
  "Obat_Amber-03": "#fbbb65",
  "Obat_Green-04": "#91d471",
  "Obat_Green-05": "#a0da85",
  "Obat_Red-04": "#ef8585",
  "Obat_Red-05": "#f29696",
  "Obat_Amber-04": "#fbc478",
  "Obat_Amber-05": "#fccc8c",
  "Obat_Blue-00": "#0e83dd",
  "Obat_Blue-10": "#e9f5fe",
  "Obat_Blue-09": "#d3eafc",
  "Obat_Grey-15": "#edf0f2",
  "Obat_Red-09": "#fbdcdc",
  "Obat_Amber-09": "#feeed9",
  "Obat_Green-09": "#dff3d6",
  "Phenix_Blue": "#0056AE",
  "Phenix_Black": "#000222",
  "Phenix_White": "#FFFFFF",
  "Phenix_Gray": "#F5F5F5",
  "Previi_Red": "#FE5F69",
  "Previi_Purple": "#896BE8",
  "Previi_Yellow": "#F6C666",
  "Previi_Gray": "#646071",
  "Previi_Blue-dark": "#100141",
  "Previi_Blue": "#2655A1",
  "Previi_Gray-light": "#F6F6F6",
  "Propulse_Primary-90": "#EFFAF2",
  "Propulse_Primary-100": "#D8EAD7",
  "Propulse_Primary-500": "#007461",
  "Propulse_Info-600": "#273344",
  "Propulse_Info-100": "#EFF0F3",
  "Propulse_Info-90": "#F7F8FA",
  "Qonto_Black": "#1d1d1b",
  "Qonto_White": "#ffffff",
  "Qonto_Gray800": "#292927",
  "Qonto_Gray700": "#393937",
  "Qonto_Gray600": "#636360",
  "Qonto_Gray500": "#999896",
  "Qonto_Gray400": "#b8b8b5",
  "Qonto_Gray300": "#dcdcd9",
  "Qonto_Gray200": "#ebebe8",
  "Qonto_Gray100": "#f3f3f0",
  "Qonto_Purple800": "#9b81f6",
  "Qonto_Mustard800": "#f1f78e",
  "Qonto_Peach800": "#ffbc90",
  "Qonto_Mint800": "#b0f0da",
  "Qonto_Purple500": "#d5c8fb",
  "Qonto_Gray700hover": "#40403e",
  "Qonto_Purple200": "#eee9fc",
  "Resco_Black": "#000000",
  "Resco_Primary": "#013399",
  "Resco_White": "#ffffff",
  "Resco_Secondary": "#ff0000",
  "Resco_Background": "#f5f8fa",
  "Revital_Blue-1": "#3772ff",
  "Revital_Green-1": "#25cdc7",
  "Revital_Blue-2": "#c9d9ff",
  "Revital_Green-2": "#b1eae8",
  "Revital_Blue-0": "#2151c3",
  "Shine_Yellow-0": "#FEE827",
  "Shine_Yellow-1": "#FFEB85",
  "Shine_Yellow-2": "#FFF5D2",
  "Shine_Yellow-3": "#FFF7DB",
  "Shine_Yellow-4": "#FFF7DB",
  "Shine_White": "#FFFFFF",
  "Shine_Green-100": "#FAFFF5",
  "Shine_Green-800": "#384B23",
  "Shine_Green-700": "#496728",
  "Shine_Green-600": "#56AA41",
  "Shine_Green-500": "#A4D36E",
  "Shine_Green-400": "#C9EBA3",
  "Shine_Green-300": "#E7F9D2",
  "Shine_Green-200": "#F0FCE4",
  "Shine_Red-800": "#843435",
  "Shine_Red-700": "#9E3D3D",
  "Shine_Red-600": "#DC4C56",
  "Shine_Red-500": "#F99D8F",
  "Shine_Red-400": "#FBC2B6",
  "Shine_Red-300": "#FFE1DD",
  "Shine_Red-200": "#FFF2F0",
  "Shine_Red-100": "#FFFBFA",
  "Shine_Orange-800": "#893815",
  "Shine_Orange-700": "#B64617",
  "Shine_Orange-600": "#F4722A",
  "Shine_Orange-500": "#FF9F6B",
  "Shine_Orange-400": "#FFC9A3",
  "Shine_Orange-300": "#FFE6C9",
  "Shine_Orange-200": "#FEF3E6",
  "Shine_Orange-100": "#FEFAF5",
  "Shine_Yellow-800": "#47350B",
  "Shine_Yellow-700": "#8E6A15",
  "Shine_Yellow-600": "#FEE827",
  "Shine_Yellow-500": "#FFEB85",
  "Shine_Yellow-400": "#FCF0B6",
  "Shine_Yellow-300": "#FFF8D2",
  "Shine_Yellow-200": "#FEFAE2",
  "Shine_Yellow-100": "#FFFDF5",
  "Shine_Blue-800": "#2B464D",
  "Shine_Blue-700": "#087CBF",
  "Shine_Blue-600": "#2A93F4",
  "Shine_Blue-500": "#8BC7FF",
  "Shine_Blue-400": "#C7E4FF",
  "Shine_Blue-300": "#E0F0FF",
  "Shine_Blue-200": "#EEF5FB",
  "Shine_Blue-100": "#FBFCFE",
  "Shine_Black": "#000000",
  "Shine_Grey-light-3": "#F0EFE4",
  "Shine_Blue-0": "#2B464D",
  "Shine_Grey-0": "#25241D",
  "Shine_Grey-1": "#555249",
  "Shine_Grey-2": "#DEDCCE",
  "Shine_Grey-3": "#F0EFE4",
  "Shine_Grey-4": "#F6F5EF",
  "Shine_Grey-5": "#FCFBF8",
  "Shine_Grey-light-0": "#7F7B71",
  "Shine_Grey-light-1": "#B6B4AA",
  "Shine_Gray-200": "#F9F9F9",
  "Shine_Gray-300": "#EFEFEF",
  "Shine_Gray-400": "#E0E0E0",
  "Shine_Gray-500": "#CDCDCD",
  "Shine_Gray-600": "#B6B6B5",
  "Shine_Gray-700": "#888785",
  "Shine_Gray-800": "#4F4F4E",
  "Shine_Gray-900": "#25241D",
  "Sidecare_Legacy-bg": "#FFFAF2",
  "Sidecare_Legacy-white": "#FFFFFF",
  "Sidecare_Legacy-black": "#000000",
  "Sidecare_Legacy-primary_900": "#0F0F0F",
  "Sidecare_Legacy-primary_800": "#301111",
  "Sidecare_Legacy-primary_700": "#D2531E",
  "Sidecare_Legacy-primary_600": "#EB662E",
  "Sidecare_Legacy-primary_500": "#FF7B44",
  "Sidecare_Legacy-primary_400": "#FF8857",
  "Sidecare_Legacy-primary_300": "#FFB08F",
  "Sidecare_Legacy-primary_200": "#FFE5DA",
  "Sidecare_Legacy-primary_100": "#FFFDF9",
  "Sidecare_Legacy-gray_900": "#0F0F0F",
  "Sidecare_Legacy-gray_800": "#3F3F3F",
  "Sidecare_Legacy-gray_700": "#636363",
  "Sidecare_Legacy-gray_600": "#6F6F6F",
  "Sidecare_Legacy-gray_500": "#9F9F9F",
  "Sidecare_Legacy-gray_400": "#CFCFCF",
  "Sidecare_Legacy-gray_300": "#CFCFCF",
  "Sidecare_Legacy-gray_200": "#E7E7E7",
  "Sidecare_Legacy-gray_100": "#F3F3F3",
  "Sidecare_Legacy-decorative_primary": "#FFF8EC",
  "Sidecare_Legacy-decorative_secondary": "#6D092A",
  "Sidecare_Legacy-Lavender ": "#E3D8FC",
  "Sidecare_Legacy-Moss ": "#E2EAB3",
  "Sidecare_Legacy-Sandy ": "#FDE6C5",
  "Sidecare_Legacy-Hazy": "#FBD8C9",
  "Sidecare_Legacy-green_900": "#003715",
  "Sidecare_Legacy-green_800": "#005922",
  "Sidecare_Legacy-green_700": "#00752D",
  "Sidecare_Legacy-green_600": "#28A156",
  "Sidecare_Legacy-green_500": "#3AC26E",
  "Sidecare_Legacy-green_400": "#61CD88",
  "Sidecare_Legacy-green_300": "#89DAA8",
  "Sidecare_Legacy-green_200": "#D8F3E2",
  "Sidecare_Legacy-green_100": "#EBF9F1",
  "Sidecare_Legacy-yellow_900": "#5A4301",
  "Sidecare_Legacy-yellow_800": "#846710",
  "Sidecare_Legacy-yellow_700": "#D1AA36",
  "Sidecare_Legacy-yellow_600": "#EFCE6F",
  "Sidecare_Legacy-yellow_500": "#FEE394",
  "Sidecare_Legacy-yellow_400": "#FEEBB4",
  "Sidecare_Legacy-yellow_300": "#FFF1C9",
  "Sidecare_Legacy-yellow_200": "#FFF7DF",
  "Sidecare_Legacy-yellow_100": "#FFFCF4",
  "Sidecare_Legacy-orange_900": "#471905",
  "Sidecare_Legacy-orange_800": "#8B320E",
  "Sidecare_Legacy-orange_700": "#D85D29",
  "Sidecare_Legacy-orange_600": "#FF7B44",
  "Sidecare_Legacy-orange_500": "#FFA656",
  "Sidecare_Legacy-orange_400": "#FFB778",
  "Sidecare_Legacy-orange_300": "#FFDBBB",
  "Sidecare_Legacy-orange_200": "#FFEDDD",
  "Sidecare_Legacy-orange_100": "#FFF6EE",
  "Sidecare_Legacy-red_900": "#410000",
  "Sidecare_Legacy-red_800": "#5B0000",
  "Sidecare_Legacy-red_700": "#8F0D0D",
  "Sidecare_Legacy-red_600": "#CB2828",
  "Sidecare_Legacy-red_500": "#FB6161",
  "Sidecare_Legacy-red_400": "#FB8181",
  "Sidecare_Legacy-red_300": "#FDC0C0",
  "Sidecare_Legacy-red_200": "#FEDFDF",
  "Sidecare_Legacy-red_100": "#FFEFEF",
  "Superindep_Legacy-bg": "#FAF9F7",
  "Superindep_Legacy-white": "#FFFFFF",
  "Superindep_Legacy-black": "#000000",
  "Superindep_Legacy-primary_900": "#0C0331",
  "Superindep_Legacy-primary_800": "#12073E",
  "Superindep_Legacy-primary_700": "#190A52",
  "Superindep_Legacy-primary_600": "#1E0F58",
  "Superindep_Legacy-primary_500": "#1F0F69",
  "Superindep_Legacy-primary_400": "#735DD7",
  "Superindep_Legacy-primary_300": "#C1B7EB",
  "Superindep_Legacy-primary_200": "#E7E4F4",
  "Superindep_Legacy-primary_100": "#F5F4FA",
  "Superindep_Legacy-gray_900": "#181818",
  "Superindep_Legacy-gray_800": "#3F3F3F",
  "Superindep_Legacy-gray_700": "#6F6F6F",
  "Superindep_Legacy-gray_600": "#939393",
  "Superindep_Legacy-gray_500": "#AEAEAE",
  "Superindep_Legacy-gray_400": "#CDCDCD",
  "Superindep_Legacy-gray_300": "#E1E1E1",
  "Superindep_Legacy-gray_200": "#EEEEEE",
  "Superindep_Legacy-gray_100": "#FBFBFB",
  "Superindep_Legacy-decorative_primary": "#E7E4F4",
  "Superindep_Legacy-decorative_secondary": "#1F0F69",
  "Superindep_Legacy-green_900": "#002713",
  "Superindep_Legacy-green_800": "#004723",
  "Superindep_green_700": "#006834",
  "Superindep_Legacy-green_600": "#009A4C",
  "Superindep_green_500": "#00CC65",
  "Superindep_Legacy-green_400": "#01FF7F",
  "Superindep_Legacy-green_300": "#47FFA2",
  "Superindep_Legacy-green_200": "#A3FFD0",
  "Superindep_Legacy-green_100": "#E6FFF2",
  "Superindep_Legacy-yellow_900": "#1D1902",
  "Superindep_Legacy-yellow_800": "#433A00",
  "Superindep_Legacy-yellow_700": "#9E8A00",
  "Superindep_Legacy-yellow_600": "#D9BD00",
  "Superindep_Legacy-yellow_500": "#FFE428",
  "Superindep_Legacy-yellow_400": "#FFEB62",
  "Superindep_Legacy-yellow_300": "#FFF195",
  "Superindep_Legacy-yellow_200": "#FFF8CB",
  "Superindep_Legacy-yellow_100": "#FFFDEE",
  "Superindep_Legacy-orange_900": "#271704",
  "Superindep_Legacy-orange_800": "#794202",
  "Superindep_Legacy-orange_700": "#B76202",
  "Superindep_Legacy-orange_600": "#FA8803",
  "Superindep_Legacy-orange_500": "#FE9925",
  "Superindep_Legacy-orange_400": "#FEB765",
  "Superindep_Legacy-orange_300": "#FED7AA",
  "Superindep_Legacy-orange_200": "#FFE9CF",
  "Superindep_Legacy-orange_100": "#FFF8EF",
  "Superindep_Legacy-red_900": "#5E021A",
  "Superindep_Legacy-red_800": "#8F062A",
  "Superindep_Legacy-red_700": "#DC1A4D",
  "Superindep_Legacy-red_600": "#F13466",
  "Superindep_Legacy-red_500": "#FF5884",
  "Superindep_Legacy-red_400": "#FF779B",
  "Superindep_Legacy-red_300": "#FF9CB7",
  "Superindep_Legacy-red_200": "#FFBACC",
  "Superindep_Legacy-red_100": "#FFECF1",
  "Tiime_Decorative_Marine": "#162351",
  "Tiime_Decorative_rose": "#ff7483",
  "Tiime_Decorative_orange": "#ff8765",
  "Tiime_Decorative_jaune": "#ffd41d",
  "Tiime_Decorative_vert": "#19d9b4",
  "Tiime_Decorative_bleu": "#54ceff",
  "Tiime_Decorative_violet": "#8089ff",
  "Tiime_Decorative_rose-light": "#ffd6db",
  "Tiime_Decorative_orange-light": "#ffdfd6",
  "Tiime_Decorative_violet-light": "#d6d9ff",
  "Tiime_Decorative_bleu-light": "#d6f3ff",
  "Tiime_Decorative_vert-light": "#dafbf5",
  "Tiime_Decorative_jaune-light": "#fff7d6",
  "Tiime_Decorative_jaune-dark": "#a88800",
  "Tiime_Decorative_bleu-dark": "#005f85",
  "Tiime_Decorative_vert-dark": "#11977d",
  "Tiime_Decorative_orange-dark": "#a82500",
  "Tiime_Decorative_violet-dark": "#000ca8",
  "Tiime_Decorative_rose-dark": "#a80012",
  "Tiime_Secondaires_Marine": "#354185",
  "Tiime_Secondaires_Gris-500": "#476388",
  "Tiime_Secondaires_Gris-400": "#6c84a2",
  "Tiime_Secondaires_Gris-300": "#88a0bf",
  "Tiime_Secondaires_Gris-200": "#bfcee1",
  "Tiime_Secondaires_Gris-100": "#e5ecf4",
  "Tiime_Secondaires_Gris-50": "#f2f5f9",
  "Tiime_Secondaires_Vert": "#53da85",
  "Gray50": "#FBFBFB"
}
